(function(){
  var dsAttr = function(type, options){
    return Em.computed(function(_,value){
      if (typeof(value) !== 'undefined') {
        return value;
      }
      return options.defaultValue || '';
    }).property();
  };

  PegasusTemplate.ImageAttributesMixin = Em.Mixin.create({
    dataBackgroundStyle: dsAttr('string', { defaultValue: 'Cover' }),
    dataIsDisplayed: dsAttr('string', { defaultValue: 'true' }),
    dataDefaultImage: dsAttr('string', { defaultValue: '' }),
    dataDefaultName: dsAttr('string', { defaultValue: '' }),
    dataSrc: dsAttr('string', { defaultValue: '' }),
    dataTop: dsAttr( 'string', { defaultValue: '0' }),
    dataLeft: dsAttr( 'string', { defaultValue: '0' }),
    dataAreaWidth: dsAttr( 'string', { defaultValue: '0' }),
    dataAreaHeight: dsAttr( 'string', { defaultValue: '0' }),
    dataMaxWidth: dsAttr( 'string', { defaultValue: '100%' }),
    dataLinkType: dsAttr('string', { defaultValue: 'Website' }),
    dataLinkUrl: dsAttr('string', { defaultValue: ''}),
    dataBorderColor:  dsAttr('string', {defaultValue: ''}),
    dataBorderStyle:  dsAttr('string', {defaultValue: 'Solid'}),
    dataBorderWidth:  dsAttr('string', {defaultValue: '0'}),
    dataName: dsAttr( 'string', { defaultValue: '' } ),
    dataAlt: dsAttr( 'string', { defaultValue: '' } ),
    dataAlignment: dsAttr( 'string', { defaultValue: 'center' } ),
    dataBorder: dsAttr('string', { defaultValue: '0' }),
    dataBorderRadius:  dsAttr('string', {defaultValue: '0'}),
    dataBorderTopPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderRightPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderBottomPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderLeftPadding:  dsAttr('string', {defaultValue: '0'}),
    dataBorderTopMargin:  dsAttr('string', {defaultValue: '0'}),
    dataBorderRightMargin:  dsAttr('string', {defaultValue: '0'}),
    dataBorderBottomMargin:  dsAttr('string', {defaultValue: '0'}),
    dataBorderLeftMargin:  dsAttr('string', {defaultValue: '0'}),
    dataIsAnimatedGif:  dsAttr('string', {defaultValue: 'false'}),
    dataIsFitDeviceWidth: dsAttr('string', { defaultValue: 'true' }),
    originalWidth: dsAttr('string', { defaultValue: '' }),
    originalHeight: dsAttr('string', { defaultValue: '' }),

    cssProperties: function(){
      return {
        height: this.get('dataHeight'),
        width: this.get('dataWidth'),
        maxWidth: this.get('dataMaxWidth'),
        border: this.get('dataBorder'),
        left: this.get('dataLeft'),
        top: this.get('dataTop')
      };
    }.observes(),

    dataWidth: function (_, value){
      if( typeof(value) !== 'undefined' ){
        return value;
      }
      return '';
    }.property(),

    dataHeight: function (_, value){
      if( typeof(value) !== 'undefined' ){
        return value;
      }
      return '';
    }.property(),


    dataFitsContainerWidth: function(_,value){
      if( typeof( value ) !== 'undefined' ){
        return value;
      }
      return false;
    }.property(),

    dataLinkTypes: function(){
      var forwardToFriendTranslation = Em.I18n.t('g.forward_to_friend').capitalize();
      var websiteTranslation = Em.I18n.t('g.website').capitalize();
      var emailTranslation = Em.I18n.t('g.email').capitalize();

      return {
        Forward: {
          willPrepend: 'http://',
          test: new RegExp( '^http(s)?:\/\/|^(s)?ftp:\/\/' ),
          display: forwardToFriendTranslation
        },
        Website: {
          willPrepend: 'http://',
          test: new RegExp( '^http(s)?:\/\/|^(s)?ftp:\/\/' ),
          display: websiteTranslation
        },
        Email: {
          willPrepend: 'mailto:',
          test: new RegExp( '^mailto:' ),
          display: emailTranslation
        }
      };
    }.property()

  });

})();
